import * as React from 'react';

// @ts-expect-error
import Formsy from 'formsy-react';

import {Popover} from 'shells/popover/popover';

import {CheckmarkSubmitButton} from '../../base/form-components/checkmark-submit-button';
// @ts-expect-error
import {FormSelect} from '../../base/form-components/form-select';
// @ts-expect-error
import {FormTextField} from '../../base/form-components/form-textfield';
// @ts-expect-error
import getClassesMixin from '../../mixins/get-classes';

const selectValues = [
    {id: 'Equals', name: 'Equals'},
    {id: 'Greater than', name: 'Greater than'},
    {id: 'Less than', name: 'Less than'},
];

type Props = {
    value: any;
    name: string;
    onDirty: (...args: any) => any; // Optional,
    onSubmit: (...args: any) => any; // Optional,
    animateIn?: boolean;
};

type State = {
    canSubmit: boolean;
    submitHover: boolean;
};

export class IntegerFormDeprecated extends React.Component<Props, State> {
    focusMe: HTMLElement | null | undefined;
    submitButton: HTMLElement | null | undefined;
    getClasses = getClassesMixin;

    static defaultProps = {
        value: {
            selected: 'Equals',
            data: '',
        },
        onSubmit: () => {},
        onDirty: () => {},
    };

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            canSubmit: false,
            submitHover: false,
        };
    }

    componentDidMount() {
        const timeoutDuration = this.props.animateIn ? 250 : 0;

        setTimeout(() => {
            if (this.focusMe) {
                this.focusMe.focus();
            }
        }, timeoutDuration);
    }

    render() {
        const {name, value} = this.props;

        return (
            <Formsy
                className='ui-form'
                // @ts-expect-error
                onChange={(data, changed) => this.props.onDirty(changed)}
                onValidSubmit={this.props.onSubmit}
                onValid={() => this.setState({canSubmit: true})}
                onInvalid={() => this.setState({canSubmit: false})}
            >
                <div className='ui-linked-select ui-linked-select__integer-form'>
                    <FormSelect
                        name={`${name}.selected`}
                        styleOptions={{fullWidth: true}}
                        value={value.selected}
                        selectValues={selectValues}
                    />
                    <FormTextField
                        name={`${name}.data`}
                        // @ts-expect-error
                        formTextfieldRef={(c) => {
                            this.focusMe = c;
                        }}
                        value={value.data}
                        required={true}
                        validations='isInt'
                        type='number'
                    />
                </div>
                <CheckmarkSubmitButton
                    className='ui-popover__submit-button'
                    getButtonRef={(c) => {
                        this.submitButton = c;
                    }}
                    disabled={!this.state.canSubmit}
                    onMouseOver={() => this.setState({submitHover: true})}
                    onMouseOut={() => this.setState({submitHover: false})}
                />
                {this.state.submitHover && !this.state.canSubmit ? (
                    <Popover anchor={this.submitButton} bodyColor='error' isDialog={true}>
                        <span>Whoops! Input must be an integer!</span>
                    </Popover>
                ) : undefined}
            </Formsy>
        );
    }
}
